﻿// "use strict";
let LoginRequired: boolean = true;
let isFirstBeforeUnload: boolean = true;
let FirstHubConnecting: boolean = true;
// Speichert die MessageProvider Informationen (Published Notification, to publish Notification etc.)
let MessageProviderObj: any;
// Wird verwendet um Popup-Meldungen (MessageProvider) zu unterdrücken (WorkMode)
let ShowPopupNotification: boolean = true;

// timer Variablen
let SessionKeepAliveTimerVar: any;
let SessionHoldRequestSendErrorCount: number = 0;
let SessionHoldRequestSendErrorCountMax: number = 4;
let SessionKeepAliveCount: number = 4;
let SessionKeepAliveCountMax: number = 4;

const CloseTimer_Default_inMin: number = 60;
const CloseTimer_Transfer_inMin: number = 60;

// Delay in seconds between showing errorMessage and closing the Tab
const ClosingWindowDelay = /*seconds*/ 5;

let LastActivity: Date = new Date();

// Portal Window open check
let PortalIdentifier: string = "active WebPortal Window";
let TransferIdentifier: string = "transfer.aspx";

// globale Variable
let hi5: any;
declare let WebPortalHubObj: any;
declare let PageMethods: any;
declare let jsSHA: any;
// Bestimmt über WebRTC die lokale Client Ip Adresse
declare let getLocalIP: any;
declare let scConverter: any;
declare let __svi18n: any;
declare let svManager: any;
declare let svGlobal: any;
declare let ChangePasswordModal: WebPortal.Dialog.Modal.ChangePassword;

let ConsoleStore = [];
let OldConsoleLog = console.log;
let OldConsoleDebug = console.debug;
let OldConsoleInfo = console.info;
let OldConsoleWarn = console.warn;
let OldConsoleError = console.error;

// Variablen für Tenant Selektion
declare var tempRequest: string;
declare var loginTenantId: number;

enum WebSiteType {
    unknown,
    default,
    transfer,
    session,
    session_join
}

// MailType - Um verschiedene Mail-Typen zu senden)
enum MailType {
    log,
    feedback
}

let ActualWebsite: WebSiteType = WebSiteType.unknown;
let ActualPage: WebPortal.Page.Basepage;
let navigationController: WebPortal.Navigation.NavigationController;
let navigationHandler: WebPortal.Navigation.NavigationHandler;

/*
* **********************************************************************
*                             Main Calls                               *
* **********************************************************************
*/
function pageLoad(sender: any, e: any): void {
    console.log('User Agent: ' + navigator.userAgent);

    WebPortal.setActualWebsite();
    switch (ActualWebsite) {
        case WebSiteType.default:
            ActualPage = new WebPortal.Page.Default.DefaultPage();
            break;
        case WebSiteType.transfer:
            ActualPage = new WebPortal.Page.Transfer.TransferPage();
            break;
        case WebSiteType.session:
            ActualPage = new WebPortal.Page.Session.SessionPage();
            break;
        case WebSiteType.session_join:
            ActualPage = new WebPortal.Page.Session.SessionJoinPage();
            break;
        default:
            ActualPage = new WebPortal.Page.Default.DefaultPage();
            break;
    }
    console.log("ActualPage.PageLoad")
    ActualPage.PageLoad(sender, e);

    // Searching local IP
    try {
        getLocalIP(function (DedectedLocalIpAddress) {
            console.info("LocalIpAddress dedected: " + DedectedLocalIpAddress);
            WebPortalHubObj.state.LocalIpAddress = DedectedLocalIpAddress;
        });
    }
    catch (exc) {
        console.error('Error to detect local IpAddress - Message: ' + (<Error>e).message);
    }

    if (!e.get_isPartialLoad()) {
        $(window).on("beforeunload", () => {
            try {
                console.warn("Before Unload");
                ActualPage.PageUnLoad();
            } catch (exc) {
                console.error(exc.message);
            }
        });
    }

    // Den Fokus bei Modals sauber initialisieren
    $('.modal').on('shown.bs.modal', function () {
        $(this).find('[autofocus]').focus();
    });

    console.log("Main PageLoad End")
}

console.log = function () {
    arguments[0] = (new Date()).toLocaleString('de-CH') + " - log - " + arguments[0];
    ConsoleStore.push(arguments[0]);
    OldConsoleLog.apply(console, arguments);
}

console.debug = function () {
    arguments[0] = (new Date()).toLocaleString('de-CH') + " - debug - " + arguments[0];
    ConsoleStore.push(arguments[0]);
    OldConsoleDebug.apply(console, arguments);
}

console.info = function () {
    arguments[0] = (new Date()).toLocaleString('de-CH') + " - info - " + arguments[0];
    ConsoleStore.push(arguments[0]);
    OldConsoleInfo.apply(console, arguments);
}

console.warn = function () {
    arguments[0] = (new Date()).toLocaleString('de-CH') + " - warn - " + arguments[0];
    ConsoleStore.push(arguments[0]);
    OldConsoleWarn.apply(console, arguments);
}

console.error = function () {
    arguments[0] = (new Date()).toLocaleString('de-CH') + " - error - " + arguments[0];
    ConsoleStore.push(arguments[0]);
    OldConsoleError.apply(console, arguments);
}

/***********************************************************************/
/*                        Show Status Messages                         */
/***********************************************************************/
interface StatusMessageOption {
    title: string;
    message: string;
    alertMessage?: string;
    acceptButtonName?: string;
    closeButtonName?: string;
    progress?: boolean;
    showAccept?: boolean;
    hasOnlyAcceptButton?: boolean;
}

function Show_Status_Message(messageOption: StatusMessageOption): void {
    if (!messageOption) return;

    $('#lb_modal_status_message_title').text(messageOption.title);
    $('#bt_modal_status_message_footer_close').text("Close");
    $('#bt_modal_status_message_footer_accept').text("Accept");
    if (messageOption.alertMessage) {
        $('#pn_modal_status_alert_message').removeClass("hidden");
        $('#pn_modal_status_alert_message').html(messageOption.alertMessage);
    } else {
        $('#pn_modal_status_alert_message').addClass("hidden");
    }
    $('#pn_modal_status_message').html(messageOption.message);
    $('#pn_modal_status_message').removeClass('alert');
    $('#pn_modal_status_message').removeClass('alert-danger');
    $('#bt_modal_status_message_footer_close').removeClass('btn-danger');
    $('#bt_modal_status_message_footer_accept').addClass('hidden');
    if (messageOption.progress) {
        $('#bt_modal_status_message_window_close').addClass('hidden');
        $('#bt_modal_status_message_footer_close').addClass('hidden');
        $('#pn_modal_status_message_progress').removeClass('hidden');
    } else {
        $('#bt_modal_status_message_window_close').removeClass('hidden');
        $('#bt_modal_status_message_footer_close').removeClass('hidden');
        if (!!messageOption.closeButtonName) {
            $('#bt_modal_status_message_footer_close').text(messageOption.closeButtonName);
        }
        $('#pn_modal_status_message_progress').addClass('hidden');
    }
    // _Progress regelt schon, ob der Closebutton kommt oder nicht somit muss nur noch true geprüft werden
    if (messageOption.showAccept) {
        $('#bt_modal_status_message_window_close').removeClass('hidden');
        $('#bt_modal_status_message_footer_close').removeClass('hidden');
        $('#bt_modal_status_message_footer_accept').removeClass('hidden');
        if (!!messageOption.acceptButtonName) {
            $('#bt_modal_status_message_footer_accept').text(messageOption.acceptButtonName);
        }
    }
    if (messageOption.hasOnlyAcceptButton) {
        $('#bt_modal_status_message_footer_close').addClass('hidden');
        $('#bt_modal_status_message_window_close').addClass('hidden');
    }
    // Evt. Buttonaktionen löschen
    $("#bt_modal_status_message_footer_close").off();
    $("#bt_modal_status_message_footer_accept").off();

    $("#pn_modal_status_messages").modal({ backdrop: 'static', keyboard: false });
}

function Show_Status_Message_Cause(_Title: string, _Cause: string, _ShowClose: boolean = false): void {
    $('#lb_modal_status_message_title').text(_Title);
    $('#bt_modal_status_message_footer_close').text("Close");
    $('#pn_modal_status_message').html(_Cause);
    $('#pn_modal_status_message').addClass('alert');
    $('#pn_modal_status_message').addClass('alert-danger');
    $('#pn_modal_status_alert_message').addClass("hidden");
    if (_ShowClose) {
        $('#bt_modal_status_message_window_close').removeClass('hidden');
        $('#bt_modal_status_message_footer_close').removeClass('hidden');
    } else {
        $('#bt_modal_status_message_window_close').addClass('hidden');
        $('#bt_modal_status_message_footer_close').addClass('hidden');
    }
    $('#pn_modal_status_message_progress').addClass('hidden');
    $('#bt_modal_status_message_footer_accept').addClass('hidden');

    // Evt. Buttonaktionen löschen
    $("#bt_modal_status_message_footer_close").off();
    $("#bt_modal_status_message_footer_accept").off();

    $("#pn_modal_status_messages").modal({ backdrop: 'static', keyboard: false });
}

function Show_Error_Message_And_Close_Window(_Title: string, _Cause: string, _CloseDelay: number = ClosingWindowDelay) {
    _Cause += "<br><br>" + "This window will be closed in " + _CloseDelay + " seconds."
    Show_Status_Message_Cause(_Title, _Cause);
    setTimeout(() => { close(); }, _CloseDelay * 1000 /*ms*/);
}

function Close_Status_Message() {
    $('#pn_modal_status_messages').modal('hide');
}

namespace WebPortal {
    export function setActualWebsite(): void {
        let pathname: string = $(location).attr("pathname");
        switch (pathname) {
            case "/":
            case "/default.aspx":
                ActualWebsite = WebSiteType.default;
                break;
            case "/transfer.aspx":
                ActualWebsite = WebSiteType.transfer;
                break;
            case "/session.aspx":
                ActualWebsite = WebSiteType.session;
                break;
            case "/session_join.aspx":
                ActualWebsite = WebSiteType.session_join;
                break;
        }
    }

    export function onSessionKeepAliveTimer(): void {
        console.debug("SessionKeepAliveTimer");
        SessionKeepAliveCount--;
        if (SessionKeepAliveCount > 0) {
            console.debug("Send KeepAlive");
            PageMethods.doSendSessionKeepAlive($("#hdf_se_request_param").val(), WebPortalHubObj.connection.id, LastActivity.toISOString(), onSessionKeepAliveTimerReason);

            // bietet eine Funktion, wenn regelmässige Aktionen durchgeführt werden müssen
            switch (ActualWebsite) {
                case WebSiteType.default:
                    (ActualPage as WebPortal.Page.Default.DefaultPage).action_onKeepAlive_Default();
                    break;
                case WebSiteType.session:
                    (ActualPage as WebPortal.Page.Session.SessionPage).action_onKeepAlive_Session();
                    break;
                case WebSiteType.transfer:
                    (ActualPage as WebPortal.Page.Transfer.TransferPage).action_onKeepAlive_Default();
                    break;
            }
        } else {
            console.error("Error on Session hold - no positiv answer from Session KeepAlive");
            clearInterval(SessionKeepAliveTimerVar);
            ActualPage.PageUnLoad();

            setTimeout(() => {
                Show_Status_Message_Cause("Session Holding Error", "Error on Session hold (Session no longer alive), please Restart Session", false);
            }, 500);
        }
    }

    // Gibt an ob die Session verfügbar ist und ob der KeepAlive abgesetzt werden konnte
    export function onSessionKeepAliveTimerReason(Result: boolean): void {
        if (!Result) {
            // console.error("Error on Session hold - KeepAliveReason is false");
            console.error("Error to send Session hold - (Session on Web server no longer exists or Message-Queue problem)");
            SessionHoldRequestSendErrorCount += 1;
            if (SessionHoldRequestSendErrorCount >= SessionHoldRequestSendErrorCountMax) {
                clearInterval(SessionKeepAliveTimerVar);
                ActualPage.PageUnLoad();

                setTimeout(() => {
                    Show_Status_Message_Cause("Session Holding Error", "Error on Session hold (no connection to send keep alive), please Restart Session", false);
                }, 500);
            }
        } else {
            SessionHoldRequestSendErrorCount = 0;
        }
    }

    export function openWindow(Param: string): void {
        let PopUpBlockerInfoAlreadyDisplayed: string = localStorage.getItem("PopUpBlockerInfoAlreadyDisplayed");
        if (!!PopUpBlockerInfoAlreadyDisplayed && PopUpBlockerInfoAlreadyDisplayed == "true") {
            WebPortal.Misc.openWindow(Param);
        } else {
            let DeactivatePopupBlockerMsg: string =
                '<p>RMS will open a new window, this will be denied by most browsers. It is necessary to disable the pop up blocker for the RMS domain.</p><hr />' + //
                '<div class="row"><div class="col-xs-12 col-md-12">' +//
                '<p><strong>First:</strong> find popup blocker message (might by top right)<br /><strong>Second:</strong> deactivate popup blocker for RMS domain' + //
                '</p></div></div>';

            Show_Status_Message({ title: "Deactivate Popup-Blocker for RMS Domain", message: DeactivatePopupBlockerMsg, closeButtonName: "OK" });

            $("#bt_modal_status_message_footer_close").off().on("click", () => {
                $("#pn_modal_status_messages").modal("hide");
                localStorage.setItem("PopUpBlockerInfoAlreadyDisplayed", "true");
                WebPortal.Misc.openWindow(Param);
                return false;
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    $("#pn_modal_status_messages").modal("hide");
                    localStorage.setItem("PopUpBlockerInfoAlreadyDisplayed", "true");
                    WebPortal.Misc.openWindow(Param);
                    return false;
                }
            });

            $("#bt_modal_status_message_window_close").off().on("click", () => {
                $("#pn_modal_status_messages").modal("hide");
                localStorage.setItem("PopUpBlockerInfoAlreadyDisplayed", "true");
                WebPortal.Misc.openWindow(Param);
                return false;
            });
        }
    }
}

namespace WebPortal.Page {
    export interface IPage {
        PageLoad(sender: any, e: any): void;
        PageUnLoad(): void;
    }

    export class Basepage implements IPage {
        public PageLoad(sender: any, e: any): void {
            if (!Modernizr.canvas || !Modernizr.websockets) {
                const isOutDatedBrowserVersionWarningAccepted = localStorage.getItem("isOutDatedBrowserVersionWarningAccepted");

                if (!isOutDatedBrowserVersionWarningAccepted) {
                    Show_Status_Message({ title: "Browser Version Not Supported", message: "Please consider updating your browser to the newest stable version.", alertMessage: "Your browser seems to not support the necessary features to use our service.", showAccept: true, acceptButtonName: "Proceed", hasOnlyAcceptButton: true })

                    $("#bt_modal_status_message_footer_accept").off().on("click", () => {
                        localStorage.setItem("isOutDatedBrowserVersionWarningAccepted", "true")
                    });
                }
            }
            else {
                localStorage.removeItem("isOutDatedBrowserVersionWarningAccepted");
            }

            // überprüft ob ein Login notwendig ist. So können gewisse Parts aus der Laderoutine ausgeschlossen werden.
            if (($("#pn_authentication") == null) || ($("#pn_authentication").length === 0)) {
                LoginRequired = false;
                document.body.style.backgroundImage = "";
            }

            // Überprüfung, ob die Information zur Tenant Auswahl bei SSO angezeigt werden soll
            let language_ID: number = 1;
            if ($("#hdf_sso_request_param").val()) {
                if ($("#hdf_settings").val()) {
                    let UserSettings = JSON.parse($("#hdf_settings").val());
                    if (!!UserSettings && !!UserSettings.Language_ID) {
                        language_ID = UserSettings.Language_ID;
                    }
                }

                Misc.ShowTenantSelection(
                    $("#hdf_sso_request_param").val(),
                    JSON.parse($("#hdf_sso_request_param_tenantlist").val()),
                    $("#hdf_sso_request_param_logintenantid").val() as number,
                    language_ID);
            }

            // überprüft den Status des Navigationsmenüs und setzt das Navigationsmenü und Content auf collapsed or expanded
            // dies muss immer gemacht werden, da sonst bei jedem PostBack der Text verschwindet
            let navState: JQuery = $("#hdf_navstate");
            if (navState.length > 0) {
                if (navState.val() === "collapsed") {
                    navigationController.collapse();
                }

                if (navState.val() === "expanded") {
                    navigationController.expand();
                }
            }

            // nur ausführen wenn es ein Page Request ist
            if (!e.get_isPartialLoad()) {
                console.log("pageLoad");

                // ********* SIGNALR FUNCTIONS ********* //
                console.info("Initialize RMS");

                this.connectToHub();

                navigationController.resize();
            }

            if (($("#pn_authentication") != null) && ($("#pn_authentication").length !== 0)) {
                console.info("Initialize Login Handler");
                let login: Dialog.Login = new WebPortal.Dialog.Login();
            }

            $("#hdf_screen_width").val(screen.width);
            $("#hdf_screen_height").val(screen.height);
        }

        protected connectToHub(): void {
            let BaseHub: Hub.BaseHub = new WebPortal.Hub.BaseHub();
            WebPortalHubObj = BaseHub.WebPortalHub();
        }

        public PageUnLoad(): void {
            console.info("PageUnLoad");
            status = "PageUnLoad";
            if (isFirstBeforeUnload) {
                isFirstBeforeUnload = false;
                clearInterval(SessionKeepAliveTimerVar);
                // deregister Session on unload
                WebPortalHubObj.server.doFinalizeBackend($("#hdf_se_request_param").val(), ActualWebsite);
                setTimeout(() => {
                    // disconnect Hub
                    console.info("WebPortalHub - disconnect hub");
                    RegularBaseHubDisconnect = true;
                    $.connection.hub.stop();
                }, 100); // Auf 100ms lassen, da ansonsten der stop nicht immer aufgerufen wird (der RMS-Client terminiert sehr schnell)
            }

            $("#hdf_se_request_param").val("");
        }
    }
}